<template>
  <div class="py-2">
    <div class="pb-1">
      <p class=" mb-0 d-flex">
          <span class="no-flex text-uppercase font-weight-bold mr-2">{{ producto.modelo }} </span>
          
      </p><span class="no-flex">{{ lineaticket.mslt_codigo_escaneo }}</span>
      <span claas="no-flex body-1 ml-2"> {{ producto.color }}</span>
    </div>
    <div class="mb-2 d-flex pb-2">
    <div class="image mr-2 no-flex" :style="{ backgroundImage: 'url(' + foto  + ')' }"></div>
    <div class="unishop-order-desc mb-2 d-flex flex-wrap">
      <div class="d-flex flex-column">
      
          <Nota @actualizar="actualizarCoste" :nota="lineaticket.mslt_nota" :coste.sync="lineaticket.mslt_coste_extra" :uidLineaTicket="lineaticket.mslt_uid" ></Nota>
   
          <p class="ml-auto no-flex mb-0 pt-1">
            <span class="no-flex mr-1">
            {{ lineaticket.mslt_unidades }} und
            </span>x<span class="no-flex mx-1">{{ formatMoney(Number(lineaticket.mslt_precio)) }}</span>
            <span class="ml-auto no-flex ml-1 subheading">{{ formatMoney(lineaticket.mslt_unidades * Number(lineaticket.mslt_precio)) }}</span>
          </p>
          <p class="font-weight-light no-flex align-center caption d-flex ml-auto mb-0" v-if="lineaticket.mslt_nota !== '' && lineaticket.mslt_nota !==null">
              <!--<span>Coste extra unitario</span>-->
              <v-icon class="grey--text subheading">edit_note</v-icon>
              <span class="mx-1 ">Nota {{ lineaticket.mslt_unidades }}</span>x
              <span class="no-flex mx-1">{{ formatMoney(Number(coste)) }}</span>=
              <span class="no-flex ml-1 subheading">{{ formatMoney(Number(lineaticket.mslt_unidades * Number(coste))) }}</span>
          </p>
           <!-- <p class="font-weight-light caption d-flex align-center mb-1">
                <span class="no-flex ml-auto">Descuento  = </span>
                <span class="no-flex ml-2 subheading">{{ formatMoney(lineaticket.mslt_descuento) }}</span>
          </p>-->
        <p class="d-flex mb-2 mt-1">
          <span class="no-flex ml-auto">Total</span>
          <span class="no-flex ml-2 title ">
            {{ formatMoney(((lineaticket.mslt_precio + Number(coste)) * lineaticket.mslt_unidades)) }}
          </span>
        </p>
      </div>
        <!-- <div class="unishop-order-options"><span>Talla: {{ }}</span></div> -->
    </div>
  </div>
    <v-divider></v-divider>
    <!-- Componente para añadir notas -->
  </div>          
</template>
<script>
import EventBus from '@/plugins/EventBus'
import { TiendaApiService } from '@/api/TiendaApiService'
import { Util } from '@/api/Util'
const tiendaApiService = new TiendaApiService()
const util = new Util()

import Nota from '../modal/Nota';

export default {
  name: 'lineaTicket',
  props: ['lineaticket'],
  components: { Nota },
  data () { 
    return {
      producto: {
        modelo: '',
        color: '',
      },
      x: 0,
      foto: '',
      talla: '',
      dialog: false,
      uidLineaTicket: '',
      coste: 0
    };
  },
  mounted () {
    console.log(this.lineaticket.mslt_nota)
    this.init()
  },
  methods: {
    init() {
      this.coste = this.lineaticket.mslt_coste_extra
      this.getArticuloByCod();
    },
    formatMoney (num) {
      return util.formatMoney(num)
    },
    actualizarCoste(costeAux) {
      this.coste = costeAux
      EventBus.$emit('listaTicketsActualizar')
    },
    getArticuloByCod () {
      tiendaApiService.getArticuloByCod(this.lineaticket.mslt_codigo_escaneo)
        .then(data => {
          if (data.articulo) {
              this.producto = data.articulo
              this.talla = data.talla
              this.getFoto()
          } else {
            this.producto.modelo = 'Articulo no encontrado'
            this.producto.color = ''
            this.foto = ''
          }
        })
        .catch(error => {
          //this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
          this.producto.modelo = 'Articulo no encontrado'
          this.producto.color = ''
          this.foto = ''
          util.mostrarEnConsola('tiendaApiService - getArticuloByCod', error, 'ERROR')
        })

    },
    getFoto() {
      if (this.producto.fotos.length > 0) {
        this.foto =  (this.producto.fotos.find(f => f.porDefecto === 'S') || {}).url;
      }   
    },
    addToCart () {
      //console.log(this.producto)
      if (this.producto) {
        // this.error = false
        Object.assign(this.producto, {cantidad: this.lineaticket.mslt_unidades})
        Object.assign(this.producto, {codigo: this.lineaticket.mslt_codigo_escaneo})
        Object.assign(this.producto, {precio: this.lineaticket.mslt_precio})
        Object.assign(this.producto, {nota: this.lineaticket.mslt_nota})
        Object.assign(this.producto, {coste: this.lineaticket.mslt_coste_extra})
        Object.assign(this.producto, {tipoNota: this.lineaticket.mslt_tipo_nota})
        if (this.producto.talla !== '') {
          Object.assign(this.producto, {talla: this.producto.talla})
        } else {
          let eanAux;
          for (var i = 0; i < this.producto.tallas.length; i++) {
            eanAux = this.producto.tallas[i].eans.find( ean => ean.ean === this.lineaticket.mslt_codigo_escaneo ); 
          }
          if (eanAux) {
            Object.assign(this.producto, {talla: this.eanAux.ean})
          }
        }
        Object.assign(this.producto, {foto: this.foto})
        this.$store.commit('addToCart', this.producto)
        return true
        //this.$emit('cerrar')
      } else {
        console.log('error desaparcar' + this.producto)
        return true
        // this.error = true
      }
    },
  }

};
</script>